/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderListItemCreateRequest } from '../../models/order-list-item-create-request';
import { OrderListItemCreateResponse } from '../../models/order-list-item-create-response';

export interface AddNewItemsToCurrentOrderList$Params {
      body: OrderListItemCreateRequest
}

export function addNewItemsToCurrentOrderList(http: HttpClient, rootUrl: string, params: AddNewItemsToCurrentOrderList$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderListItemCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, addNewItemsToCurrentOrderList.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderListItemCreateResponse>;
    })
  );
}

addNewItemsToCurrentOrderList.PATH = '/order-lists/current/items';
